<template>
  <div class="row">
    <div
      class="es-xs-12 es-sm-6 es-md-4 u-padding-xsmall"
      :class="{ 'es-lg-4': !creatingPdf, 'es-lg-6': creatingPdf }"
    >
      <div class="u-background-color-white o-card__padding-small">
        <h5 class="u-margin-bottom-xsmall">
          {{ $t("cyclesForm.airSideFeatures") }}
        </h5>
        <ul class="c-list">
          <li class="c-list__item">
            <span> {{ $t("cyclesForm.constantAirFlowRate") }}</span>
            {{
              $t(`common.${cycle.cycleCalculateValueInfo.constantAirFlowRate}`)
            }}
          </li>
          <li class="c-list__item">
            <span>{{ $t("cyclesForm.variableAirFlowRate") }}</span>
            {{
              $t(`common.${cycle.cycleCalculateValueInfo.variableAirFlowRate}`)
            }}
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cyclesForm.condensingTemp")
            }}</span>
            {{ cycle.cycleCalculateValueInfo.condensingTemp }} °C
          </li>

          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cyclesForm.condenserFanFlow")
            }}</span>
            {{ cycle.condenserFanFlow }} m³/h
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cyclesForm.condenserAirInletTemp")
            }}</span>
            {{ cycle.condenserAirInletTemp }} °C
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cyclesForm.condenserAirInletHumidity")
            }}</span>
            {{ cycle.condenserAirInletHumidity }} %
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cyclesForm.evaporatorFanFlow")
            }}</span>
            {{ cycle.evaporatorFanFlow }} m³/h
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cyclesForm.evaporatorAirInletTemp")
            }}</span>
            {{ cycle.evaporatorAirInletTemp }} °C
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cyclesForm.evaporatorAirInletHumidity")
            }}</span>
            {{ cycle.evaporatorAirInletHumidity }} %
          </li>
        </ul>
      </div>
      <div
        class="u-background-color-filtered o-card__padding-small u-margin-top-xsmall"
      >
        <ul class="c-list">
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cyclesForm.condenser")
            }}</span>
            <div class="u-text-align-right">
              <router-link
                :to="{
                  name: 'batteries-detail',
                  params: { id: cycle.condenserBatteryInfo.id },
                }"
                class="u-color-inherit"
              >
                {{ cycle.condenserBatteryInfo.name }}
              </router-link>
            </div>
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cyclesForm.condenserQuantity")
            }}</span>
            {{ cycle.cycleCalculateValueInfo.condQuantity }}
          </li>
          <!-- <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cyclesForm.condAbsoluteFlowDifference")
            }}</span>
            {{ cycle.cycleCalculateValueInfo.condAbsoluteFlowDifference }}
          </li> -->
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.condenserCapacity")
            }}</span>
            {{ cycle.condenserCapacity }} kW
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.condenserTemperature")
            }}</span>
            {{ cycle.condenserTemperature }} °C
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.condenserFldMassFlow")
            }}</span>
            {{ cycle.condenserFldMassFlow }} kg/h
          </li>

          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.condenserAirPressureDrop")
            }}</span>
            {{ cycle.condenserAirPressureDrop }} Pa
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.condenserAirTemperatureOutlet")
            }}</span>
            {{ cycle.condenserAirTemperatureOutlet }} °C
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.condenserAirHumidityOutlet")
            }}</span>
            {{ cycle.condenserAirHumidityOutlet }} %
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.condenserAirTemperatureWetbulbOutlet")
            }}</span>
            {{ cycle.condenserAirTemperatureWetbulbOutlet }} °C
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.condenserAirVelocityOutlet")
            }}</span>
            {{ cycle.condenserAirVelocityOutlet }} m/s
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.condenserFldPressureDrop")
            }}</span>
            {{ cycle.condenserFldPressureDrop }} kPa
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.condenserFldPressureDropKelvin")
            }}</span>
            {{ cycle.condenserFldPressureDropKelvin }} K
          </li>
        </ul>
      </div>
    </div>
    <div
      class="es-xs-12 es-sm-6 es-md-4 u-padding-xsmall"
      :class="{
        'es-lg-4': !creatingPdf,
        'es-lg-6': creatingPdf,
      }"
    >
      <div
        class="u-background-color-white u-background-color-white o-card__padding-small"
      >
        <h5 class="u-margin-bottom-xsmall">
          {{ $t("cyclesForm.cycleOutput") }}
        </h5>
        <ul class="c-list">
          <li class="c-list__item">
            <strong class="u-color-inherit">{{
              $t("cycleDetail.coolingCapacity")
            }}</strong>
            <strong> {{ cycle.coolingCapacity }} kW</strong>
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{ $t("cycleDetail.work") }}</span>
            {{ cycle.work }} kW
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.rejectedHeat")
            }}</span>
            {{ cycle.rejectedHeat }} kW
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.massFlow")
            }}</span>
            {{ cycle.massFlow }} kg/h
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.sensibleCapacity")
            }}</span>
            {{ cycle.sensibleCapacity }} kW
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.sensibleHeatRatio")
            }}</span>
            {{ cycle.sensibleHeatRatio }} %
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.drainWaterFlow")
            }}</span>
            {{ cycle.drainWaterFlow }} kg/h
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.compressor")
            }}</span>
            {{ cycle.compressor }} kW
          </li>
        </ul>
      </div>
      <div
        class="u-background-color-filtered o-card__padding-small u-margin-top-xsmall"
      >
        <ul class="c-list">
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cyclesForm.evaporator")
            }}</span>
            <div class="u-text-align-right">
              <router-link
                :to="{
                  name: 'batteries-detail',
                  params: { id: cycle.evaporatorBatteryInfo.id },
                }"
                class="u-color-inherit"
              >
                {{ cycle.evaporatorBatteryInfo.name }}
              </router-link>
            </div>
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cyclesForm.evaporatorQuantity")
            }}</span>
            {{ cycle.cycleCalculateValueInfo.evapQuantity }}
          </li>
          <!-- <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cyclesForm.evapAbsoluteFlowDifference")
            }}</span>
            {{ cycle.cycleCalculateValueInfo.evapAbsoluteFlowDifference }}
          </li> -->

          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.evaporatorCapacity")
            }}</span>
            {{ cycle.evaporatorCapacity }} kW
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.evaporatorTemperature")
            }}</span>
            {{ cycle.evaporatorTemperature }} °C
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.evaporatorFldMassFlow")
            }}</span>
            {{ cycle.evaporatorFldMassFlow }} kg/h
          </li>

          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.evaporatorAirPressureDrop")
            }}</span>
            {{ cycle.evaporatorAirPresseDrop }} Pa
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.evaporatorAirTemperatureOutlet")
            }}</span>
            {{ cycle.evaporatorAirTemperatureOutlet }} °C
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.evaporatorAirHumidityOutlet")
            }}</span>
            {{ cycle.evaporatorAirHumidityOutlet }} %
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.evaporatorAirTemperatureWetbulbOutlet")
            }}</span>
            {{ cycle.evaporatorAirTemperatureWetbulbOutlet }} °C
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.evaporatorAirVelocityOutlet")
            }}</span>
            {{ cycle.evaporatorAirVelocityOutlet }} m/s
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.evaporatorFldPressureDrop")
            }}</span>
            {{ cycle.evaporatorFldPressureDrop }} kPa
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cycleDetail.evaporatorFldPressureDropKelvin")
            }}</span>
            {{ cycle.evaporatorFldPressureDropKelvin }} K
          </li>
        </ul>
      </div>
    </div>
    <div
      class="es-xs-12 es-sm-12 es-md-4 u-padding-xsmall"
      :class="{
        'es-lg-4': !creatingPdf,
        'es-lg-6 u-margin-top-xlarge': creatingPdf,
      }"
    >
      <div class="u-background-color-white o-card__padding-small">
        <h5 class="u-margin-bottom-xsmall">
          {{ $t("cyclesForm.compressorOutput") }}
        </h5>
        <ul class="c-list">
          <li class="c-list__item">
            <strong class="u-color-inherit">{{
              $t("cyclesForm.compressor")
            }}</strong>
            <div class="u-width-100% u-text-align-right">
              <strong>
                {{ cycle.cycleCalculateValueInfo?.compressorBrandInfo?.title }}
              </strong>
              <div>
                {{
                  cycle.cycleCalculateValueInfo?.compressorBrandRefrigerantInfo
                    ?.title
                }}
                -
                {{
                  cycle.cycleCalculateValueInfo?.compressorRefrigerantModelInfo
                    ?.title
                }}
              </div>
            </div>
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cyclesForm.compressorCapacity")
            }}</span>
            {{ cycle.compressorRefCapacity }} kW
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cyclesForm.heatingCapacity")
            }}</span>
            {{ cycle.compressorCondCapacity }} kW
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cyclesForm.compressorMassFlow")
            }}</span>
            {{ cycle.compressorRefMassFlow }} kg/h
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cyclesForm.compressorPower")
            }}</span>
            {{ cycle.compressorElectricalPower }} kW
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cyclesForm.compressorCurrent")
            }}</span>
            {{ cycle.compressorCurrent }} A
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cyclesForm.superheat")
            }}</span>
            {{ cycle.cycleCalculateValueInfo.superheat }} K
          </li>
          <li class="c-list__item">
            <span class="u-color-inherit">{{
              $t("cyclesForm.subcooling")
            }}</span>
            {{ cycle.cycleCalculateValueInfo.subcooling }} K
          </li>
        </ul>
      </div>
      <!-- <div v-if="!creatingPdf" class="u-overflow-x-auto">
        <CycleSchema :cycle="cycle"></CycleSchema>
      </div> -->
    </div>
    <div
      class="es-xs-12"
      :class="{ 'u-margin-top-xlarge u-margin-bottom-xlarge': !creatingPdf }"
    >
      <CycleSchema :creatingPdf="creatingPdf" :cycle="cycle"></CycleSchema>
    </div>
  </div>
</template>

<script>
import CycleSchema from "./CycleSchema.vue";
export default {
  components: {
    CycleSchema,
  },
  props: {
    cycle: {
      type: Object,
      required: true,
    },
    creatingPdf: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    col() {
      return this.creatingPdf ? 6 : 4;
    },
  },
};
</script>

<style></style>
